import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => {
  return {
    root: props => ({
      borderBottom: `solid 1px ${theme.palette.grey[100]}`,
      lineHeight: '19px',
      gridRow: '1',
      display: 'inline-grid',
      gridTemplateColumns: props.templateColumns,
      fontSize: '14px',
      fontWeight: 600,
      color: theme.palette.grey[800],
      textAlign: 'left',
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: theme.palette.grey[100],
      },
    }),
  };
});

const ListRow = forwardRef(function ListRow(
  { data, className, rowIndex, rowColumns, templateColumns, ...restProps },
  ref
) {
  const classes = useStyles({ templateColumns });
  const columns = rowColumns.map((column, columnIndex) => {
    const Col = column.type;
    const key = `row-${rowIndex}-column-${columnIndex}`;
    return <Col key={key} data={data} />;
  });

  return (
    <div className={clsx(classes.root, className)} ref={ref} {...restProps}>
      {columns}
    </div>
  );
});

ListRow.propTypes = {
  className: Proptypes.string,
  /* eslint-disable-next-line */
  data: Proptypes.object.isRequired,
  rowIndex: Proptypes.number,
  rowColumns: Proptypes.arrayOf(Proptypes.element).isRequired,
  templateColumns: Proptypes.string.isRequired,
};

ListRow.defaultProps = {
  className: null,
  rowIndex: null,
};

ListRow.displayName = 'ListRow';

export default ListRow;
